import { createContext } from 'react';
import { ReactNode } from 'react';
import { useState } from 'react';

interface DraggingHerdContextType {
    draggingHerdId: string | undefined;
    setDraggingHerdId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const DraggingHerdContext = createContext<DraggingHerdContextType>(
    {} as DraggingHerdContextType,
);

export const DraggingHerdContextProvider = ({ children }: { children: ReactNode }) => {
    const [draggingHerdId, setDraggingHerdId] = useState<string | undefined>(undefined);
    return (
        <DraggingHerdContext.Provider value={{ draggingHerdId, setDraggingHerdId }}>
            {children}
        </DraggingHerdContext.Provider>
    );
};
